import { useHistory } from 'react-router'
import './Thankyou.scss'
export default function Thankyou() {
  const history = useHistory()
  const backToHome=()=>{
    history.push('/')
  }
  return (
    <div className="container-lg">
      <div className="wrapperThank">
        <div className="containerThank">
          <h2>Thank you for your interest.</h2>
          <span className="d-block mt-5">
            Please subscribe
            <a href="#/" target="_blank" rel="noopener noreferrer">telegram bot</a>
            or official <a href="https://t.me/deficandyio" target="_blank" rel="noopener noreferrer">telegram</a> group to get token sale update.
          </span>
          <span className="d-block mt-5 txt-aware">
            Beware of SCAMMERS! We have not released the token yet!
          </span>
        </div>
        <a className="backToHome" onClick={backToHome}>Back To Home</a>
      </div>
    </div>
  )
}
